<script setup lang="ts">
defineOptions({
  name: 'IntroComponent'
})

const { elementReference, isReady, isRevealed } = useScrollReveal()
</script>

<template>
  <div ref="elementReference" :class="{ reveal: isReady, revealed: isRevealed }">
    <div class="pt-high">
      <v-row align="center">
        <v-col cols="12" lg="6" class="intro-image-col">
          <NuxtImg class="intro-image" src="/images/andreas_szklarek.webp" alt="Andreas Szklarek" />
        </v-col>
        <v-col cols="12" lg="6" class="intro-text-col">
          <h1 class="text-primary bannerTitle font-weight-regular intro-heading">
            johnsenpartner. architekten
          </h1>
          <h2 class="text-h3 font-weight-regular intro-subheading">
            Wir realisieren Gebäude für Produzierende, Entwickler und Investoren.
          </h2>
          <p class="text-body-1 intro-body">
            Unser Unternehmen hat sich auf den Fertigbau spezialisiert. Als Baumanager/Generalist
            setzen wir Projekte im Neubau- wie im Umbaubereich für Sie um. Wir realisieren Gebäude,
            berechnen die Statik, planen die Gebäudetechnik und bauen ihre Außenanlagen. Unsere
            Konzepte sind auf System-, Modul- oder Holztafelbau ausgelegt aber auch auf
            Hybridbauweise oder konventionell in Stein auf Stein und Beton. Als erfahrenes
            Unternehmen sind wir schnell, kosteneffizient und unkompliziert. Ganz nach dem Motto
            &bdquo;just do it&ldquo; .
          </p>
          <NuxtLink to="/leistungen" class="custom-hyperlink text-primary font-weight-semibold"
            >Unsere Leistungen</NuxtLink
          >
        </v-col>
      </v-row>
    </div>
  </div>
</template>

<style scoped lang="scss">
.intro-image-col {
  padding-bottom: 2rem;

  @media (min-width: 1280px) {
    padding-bottom: 0;
  }
}

.intro-image {
  width: 100%;

  @media (min-width: 1280px) {
    margin-top: 4rem;
    margin-bottom: 4rem;
  }
}

.intro-text-col {
  padding-left: 2rem;
  padding-right: 2rem;

  @media (min-width: 1280px) {
    padding-left: 4rem;
    padding-right: 4rem;
  }
}

.intro-heading {
  margin-bottom: 2rem;
}

.intro-subheading {
  margin-bottom: 0.75rem;
}

.intro-body {
  margin-bottom: 1rem;
}
</style>
